<div class="page-container">
  <app-configurable-grid
    headerTitle="Identical Design"
    [config]="gridConfig">
  </app-configurable-grid>
</div>
